export default __webpack_public_path__ + "static/media/xls.3161941a.svg";